export default __webpack_public_path__ + "static/media/StarsGreen.888e39d5.svg";